import React from 'react'

type IconProps = { size?: number; className?: string }

export const IconTrophy: React.FC<IconProps> = ({ size = 22, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M8 21h8"/>
    <path d="M12 17v4"/>
    <path d="M7 4h10v3a5 5 0 0 1-10 0V4Z"/>
    <path d="M17 4h4v2a4 4 0 0 1-4 4"/>
    <path d="M7 4H3v2a4 4 0 0 0 4 4"/>
  </svg>
)

export const IconChart: React.FC<IconProps> = ({ size = 22, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M3 3v18h18"/>
    <rect x="7" y="11" width="3" height="7" rx="1"/>
    <rect x="12" y="7" width="3" height="11" rx="1"/>
    <rect x="17" y="13" width="3" height="5" rx="1"/>
  </svg>
)

export const IconUsers: React.FC<IconProps> = ({ size = 22, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
)

export const IconUser: React.FC<IconProps> = ({ size = 22, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
)

export const IconPlay: React.FC<IconProps> = ({ size = 26, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M8 5v14l11-7-11-7z" />
  </svg>
)

export const IconMore: React.FC<IconProps> = ({ size = 22, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <circle cx="5" cy="12" r="2" />
    <circle cx="12" cy="12" r="2" />
    <circle cx="19" cy="12" r="2" />
  </svg>
)

export const IconBell: React.FC<IconProps> = ({ size = 22, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9"/>
    <path d="M13.73 21a2 2 0 01-3.46 0"/>
  </svg>
)

// Tiny gender/person icons (very lightweight SVGs)
export const IconPersonMale: React.FC<IconProps> = ({ size = 28, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="7" r="3" />
    <path d="M6 21v-3a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5v3" />
  </svg>
)

export const IconPersonFemale: React.FC<IconProps> = ({ size = 28, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="7" r="3" />
    <path d="M8 21v-2a6 6 0 0 1 6-6" />
    <path d="M16 21v-6a4 4 0 0 0-4-4H9" />
  </svg>
)
